module.exports = __webpack_public_path__ + "static/media/600EchoStNW_2018-06-25_130.f1b0bbf7.jpg";